import { ItemsPerPageSchema, PageSchema } from '@vs-shop/schemas/url/queryParams/pagination';
import { Effect, Option } from 'effect';

import { productsPerPageDefault } from '../../config/pagination';
import { itemsPerPageParamName, pageParamName } from '@vs-shop/schemas/config/urlParams';

import { RuntimeClientAtom } from '../../runtime/RuntimeClient';
import * as Atom from 'effect/unstable/reactivity/Atom';

export const pageSearchParamAtom = Atom.searchParam(pageParamName, {
  schema: PageSchema,
}).pipe(Atom.withServerValue(() => Option.none()));

export const loadMorePagesAtom = Atom.make<number>(0);

export const lastPageLoadedIncludingLoadMoreAtom = Atom.readable((ctx) => {
  return ctx.get(currentPageAtom);
}).pipe(Atom.withServerValue(() => 1));

export const itemsPerPageSearchParamAtom = Atom.searchParam(itemsPerPageParamName, {
  schema: ItemsPerPageSchema,
}).pipe(Atom.withServerValue(() => Option.none()));

export const currentPageAtom = Atom.map(pageSearchParamAtom, (pageOption) =>
  Option.getOrElse(pageOption, () => 1)
).pipe(Atom.withServerValue(() => 1));

export const currentItemsPerPageAtom = Atom.map(itemsPerPageSearchParamAtom, (itemsOption) =>
  Option.getOrElse(itemsOption, () => productsPerPageDefault)
).pipe(Atom.withServerValue(() => productsPerPageDefault));

export const pagination = Atom.make((get) => {
  const page = get(currentPageAtom);
  const itemsPerPage = get(currentItemsPerPageAtom);
  return { page, itemsPerPage };
}).pipe(Atom.withServerValue(() => ({ page: 1, itemsPerPage: productsPerPageDefault })));

export type ChangeNumberAtom = (value: number | ((value: number) => number)) => void;

export type ChangeNumberAtomPromise = (
  value: number | typeof Atom.Reset | typeof Atom.Interrupt
) => Promise<void>;

export const changeProductPageAtomFn = RuntimeClientAtom.fn(
  (page: number, ctx) =>
    Effect.gen(function* () {
      yield* Effect.logDebug('🔄 changeProductPageAtomFn', page);
      ctx.set(pageSearchParamAtom, Option.some(page));
      ctx.set(loadMorePagesAtom, 0);
    }),
  {
    // reactivityKeys: [createProductReactivityKey.products()],
  }
);
